import React, { useEffect, useRef, useState } from 'react';
import { Box, IconButton, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/i18n';

const languageOptions = [
    { get label() { return i18n.t('header.english'); }, value: 'en', flag: '/assets/images/languageflags/English.png' },
    // { label: 'French', value: 'fr', flag: '/assets/img/flags/fr.png' },
    // { label: 'Spanish', value: 'es', flag: '/assets/img/flags/es.png' },
    // { label: 'German', value: 'de', flag: '/assets/img/flags/de.png' },
];

const HeaderLanguageDropdown = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [selectedOption, setSelectedOption] = useState(languageOptions[0]);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleSelect = (option) => {
        setSelectedOption(option);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <Box ref={dropdownRef} className="year-dropdown">
            <Tooltip title={t('header.languageChange')}>
                <Box className="year-dropdown-header"
                    onClick={toggleDropdown}
                    sx={{
                        p:'0!important',
                        color: theme.palette.background.text,
                        borderColor: theme.palette.custom.borderColor,
                        backgroundColor: isOpen ? theme.palette.custom.listMenuhoverbg : 'transparent',
                    }}
                >
                            <IconButton
                              className="head-icon-btn"
                              sx={{ color: theme.palette.background.text, borderColor: theme.palette.custom.borderColor }}
                            >
                    {/* <IconLanguage stroke={2} size={16}/> */}
                    <i class="fa-sharp fa-regular fa-language fs-16"></i>
                    </IconButton>
                    {/* <img src={selectedOption.flag} alt={selectedOption.label} width="20" height="20" />   */}
                    {/* {!isMobile && (<span>{selectedOption.label}</span>)} */}
                </Box>
            </Tooltip>
            {isOpen && (
                <Box
                    component="ul"
                    className="year-dropdown-list"
                    sx={{
                        width: '170px!important',
                        overflow: 'hidden',
                        backgroundColor: theme.palette.background.bgwhite,
                    }}
                >
                    {languageOptions.map((option, index) => (
                        <Box
                            component="li"
                            key={index}
                            onClick={() => handleSelect(option)}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '8px 20px!important',
                                cursor: 'pointer',
                                color: theme.palette.background.text,

                                '&:hover': {
                                    backgroundColor: theme.palette.custom?.listMenuhoverbg || '#f0f0f0',
                                },
                            }}
                        >
                            <img src={option.flag} alt={option.label} width="20" height="20" style={{ marginRight: '8px' }} />
                            <span>{option.label}</span>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default HeaderLanguageDropdown;
